export default "__VITE_ASSET__70be5550__"